<!--
 * @Author: Merlin
 * @Date: 2024-03-11 09:59:25
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-15 16:12:17
 * @Description: 组件用于显示游戏下方大表格的“押注金额” 信息 
-->
<template>
    <div class="inline-flex items-center">
        <CurrentCoin
            :name="currencyName"
            class="flex mr-1"
            size="16px"
        />
        <!-- ↑ 币种图标 -->
        <!-- ↓ 金额 -->
        <span class="text-[13px] w-full inline-block">
            <span class="flex-1 inline-flex w-full"
                :class="[validateNumberCalss]"
            >
        <ClientOnly>
                <Popper
                    v-if="showPharaoBonusGameAmount"
                    hover
                    arrow
                    placement="top"
                    :style="popperStyle"
                >
                    <CasinoWidgetColoredAmount
                        :amount="amountForShow"
                        :colors="[
                            '',
                            history.winAmount >= 10_000 ? 'inherit' : '#55657e',
                        ]"
                        :accuracy="(amountForUse >= 1_000) ? 1 : 2"
                        class="underline"
                    ></CasinoWidgetColoredAmount>
                    <!--  -->
                    <template #content>
                        <div class="popper-content" >
                            <p class="small-title" >
                                {{ $t('pharaoh.BuyBonusPrice') }}
                            </p>
                            <div class="amount-info" >
                                <CurrentCoin :name="currencyName" size="16px" />
                                <CasinoWidgetColoredAmount
                                    :amount="history.amount"
                                    :colors="['#fff', '#55657e']"
                                ></CasinoWidgetColoredAmount>
                                <span>
                                    {{currencyName.toUpperCase()}}
                                </span>
                            </div>
                        </div>
                    </template>
                </Popper>
                <CasinoWidgetColoredAmount
                    v-else
                    :amount="amountForShow"
                    :colors="[
                        '',
                        history.winAmount >= 10_000 ? 'inherit' : '#55657e',
                    ]"
                    :accuracy="(amountForUse >= 1_000) ? 1 : 2"
                ></CasinoWidgetColoredAmount>
            </ClientOnly>
            </span>
        </span>
    </div>
</template>

<script setup lang="ts">
import Popper from "vue3-popper";
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';

const props = defineProps({
    history: { // pharaoh 游戏会用到 
        type: Object as PropType<BetHistoryType>,
        default: () => ({}),
    },
    currencyName: {
        type: String,
        default: '',
    },
    amount: {
        type: Number,
        default: 0,
    },
    validateNumberCalss: {
        type: String,
        default: 'text-white',
    },
    showPharaoBonusGameAmount: {
        type: Boolean,
        default: false, // pharaoh 游戏专用，表示是用户是否买了特奖 
    },
});

const popperStyle = {
    '--popper-theme-background-color': '#202A39', 
    '--popper-theme-background-color-hover': '#202A39', 
    '--popper-theme-border-radius': '8px',
    '--popper-theme-padding': '8px 12px',
    '--popper-theme-box-shadow': '3px 6px 9px rgba(0, 0, 0, 0.35)',
};

// ↓ 最终使用的金额 
const amountForUse = computed(()=>{
    if (props.showPharaoBonusGameAmount){
        return props.history['bonusGameAmount'];
    }
    return props.amount;
});


// ↓ 最终显示的下注金额 
const amountForShow = computed(()=>{
    // ↓ 赢钱金额高达5位数(1万)时，将下注金额+返现金额都显示为 **K 
    // ↓ && 本金至少大于 10 (0.01K) 时，才显示 **K 
    if (
        props.history.winAmount >= 10_000
        && props.history.amount >= 10
    ){
        const sValue = getFixed(amountForUse.value / 1_000) + 'K';
        const aValue = sValue.split('.');
        return [aValue[0], '.' + aValue[1]];
    }else{
        return amountForUse.value;
    }
});

</script>

<style lang="scss" scoped>
.underline{
    text-decoration: underline;
    text-decoration-style: dashed;
    text-decoration-color: #aaa;
}

.popper-content{
    font-size: 12px;
    color: var(--color_grey-20);
    font-weight: normal;
}

.amount-info{
    display: flex;
    align-items: center;
    font-weight: 500;
    margin: 5px 0 0;
    &>*{
        margin-left: 3px;
    }
}

</style>

